<template>
  <div class="Menu">
    <div class="header-hamburger-navi-area">
      <div class="header-hamburger-navi-box">
        <!-- s: profile-area -->
        <div class="profile-area" @click="mypageSlideView">
          <div class="photo-area">
            <p class="ir"
               :style="'background-image: url('+userProfileImg+')'">
              사용자 이미지
            </p>
            <a class="btn-profile-edit ir">사진편집</a>
            <div class="nickname-area">
              <strong>{{ userProfileName }}<span>님</span></strong>
              <span>{{ userProfileId }}</span>
            </div>
            <button class="btn-hamburger-close ir" @click.stop="slidePanelClose">메뉴 닫기</button>
          </div>
        </div>
        <!-- e: profile-area -->

        <!-- 구매한 상품정보가 있을 경우 -->
        <div class="menu-payment" v-if="production.strProductName">
          <h3>모비고</h3>
          <h2>{{ production.strProductName }}</h2>
          <h4>
            <strong>월정액</strong> {{ production.strDueDate.split(",")[0] }}
            <strong>{{ production.strDueDate.split(",")[1] }}</strong>
          </h4>
        </div>
        <!-- 구매한 상품정보가 없는 경우 -->
        <!--                @click="payMentHelpSlideView"-->
        <div v-else class="menu-banner">
          <img src="@/assets/images/menu-banner-normal.png" width="100%"/>
        </div>

        <div class="noti-area">
          <button class="btn-note" @click="noteSlideView">
            쪽지
            <strong>{{ notiCnt }}</strong>
          </button>
          <button class="btn-noti"
                  @click="notiLink"
                  :class="{ 'active' : noticeCnt > 0 }">
            공지
          </button>
        </div>

        <!-- s: navi-area -->
        <nav class="navi-area middle-scroll">
          <ul class="navi">
            <li :class="{active : isCoumunityMenu}">
              <a @click="isCoumunityMenu = !isCoumunityMenu">
                {{ $store.state.boardList.community.strMenuName }}
              </a>
              <i class="arrow"></i>
              <transition name="slide">
                <ul class="sub-menu" v-show="isCoumunityMenu">
                  <li v-for="menu in $store.state.boardList.community.child"
                      :key="menu.nMenuNum">
                    <a v-if="menu.bAllowAccessMenu"
                       @click="pageMove(menu.nMenuNum)">
                      {{ menu.strMenuName }}
                    </a>
                    <a v-else
                       @click="toastMsg('상품구매 후 이용이 가능합니다',1500)"
                       style="color: #8f8e8e;">
                      {{ menu.strMenuName }}
                    </a>
                  </li>
                </ul>
              </transition>
            </li>
            <li :class="{active : isServiceMenu}">
              <a @click="isServiceMenu = !isServiceMenu">
                {{ $store.state.boardList.serviceCenter.strMenuName }}
              </a>
              <i class="arrow"></i>
              <transition name="slide">
                <ul class="sub-menu" v-show="isServiceMenu">
                  <li v-for="menu in $store.state.boardList.serviceCenter.child"
                      :key="menu.nMenuNum">
                    <a v-if="menu.bAllowAccessMenu"
                       @click="pageMove(menu.nMenuNum)">
                      {{ menu.strMenuName }}
                    </a>
                    <a v-else
                       @click="toastMsg('상품구매 후 이용이 가능합니다',1500)">
                      {{ menu.strMenuName }}
                    </a>
                  </li>
                </ul>
              </transition>
            </li>
            <li v-if="bDebugMode">
              <a @click="debugModeLink">
                DEBUG :: 도메인 리스트
              </a>
              <i class="arrow"></i>
            </li>
          </ul>
        </nav>

        <!-- e: navi-area -->
        <div class="menu-banner mrg-top-20 mrg-horizon-15">
          <img src="@/assets/images/menu-banner-community.png" width="100%"/>
        </div>
        <div class="logout-area mrg-top-10 mrg-horizon-15 mrg-btm-20">
          <button @click="logoutFun">로그아웃</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'Menu',
  data() {
    return {
      isCoumunityMenu: false,  // 커뮤니티 메뉴 활성화 여부
      isServiceMenu: false,    // 고객센터 메뉴 활성화 여부
      userProfileImg: '',      // 사용자 이미지
      userProfileName: '',     // 사용자 이름
      userProfileId: '',       // 사용자 아이디
      production: {},         // 상품정보
      notiCnt: 0,              // 쪽지수
      noticeCnt: 0,            // 공지수
      bDebugMode: false,          // 디버그 모드
    }
  },
  // 감시자
  watch: {},
  // $el 생성전
  created() {
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;

    this.gnbProfileFunc();
    this.gnbNotiFunc();
    this.gnbNoticeFunc();
    this.gnbProductionFunc();
  },
  methods: {
    // APP 뒤로가기
    callbackBackKey() {
      this.slidePanelClose();
    },
    // 프로필
    gnbProfileFunc() {
      let param = {};
      this.ajaxGetAuth('/api/v1/gnb/profile', param, this.gnbProfileFuncResult);
    },
    // 프로필 결과
    gnbProfileFuncResult(response) {
      let result = response.result;
      if (result.code == 0) {
        this.userProfileImg = response.oProfile.oUser.profileImg;
        this.userProfileName = response.oProfile.oUser.strNickName;
        this.userProfileId = response.oProfile.oUser.strUserId;
        this.bDebugMode = response.oProfile.oUser.bDebugMode;
      } else {
        this.toastMsg(result.resultNoti.message);
      }
    },
    // 상품정보
    gnbProductionFunc() {
      let param = {};

      this.ajaxGetAuth('/api/v1/gnb/production', param, this.gnbProductionFuncResult);
    },
    // 상품정보 결과
    gnbProductionFuncResult(response) {
      let result = response.result;
      if (result.code == 0) {
        this.production = response.oProduction;
      } else {
        this.toastMsg(result.resultNoti.message);
      }
    },
    // 상품안내 Slide
    payMentHelpSlideView() {
      this.slidePanelClose('close');
      const panel = this.$showPanel({
        component: () => import('@/views/slide/PaymentHelp'),
        openOn: 'right',
        width: screen.width,
      });
      panel.promise.then(result => {
        window.callbackBackKey = this.callbackBackKey;
        if (result.result === "close") {
          this.slidePanelClose(result);
        }
      });
    },
    // 쪽지수
    gnbNotiFunc() {
      let param = {};
      this.ajaxGetAuth('/api/v1/gnb/noti', param, this.gnbNotiFuncResult);
    },
    // 쪽지수 결과
    gnbNotiFuncResult(response) {
      let result = response.result;
      if (result.code == 0) {
        this.notiCnt = response.oNote.cnt;
      } else {
        this.toastMsg(result.resultNoti.message);
      }
    },
    // 쪽지 slide
    noteSlideView() {
      const panel = this.$showPanel({
        component: () => import('@/views/slide/Note'),
        openOn: 'right',
        width: screen.width,
      });
      panel.promise.then(result => {
        window.callbackBackKey = this.callbackBackKey;
        if (result == "close") {
          this.slidePanelClose(result);
        }
      });
    },
    // 공지수
    gnbNoticeFunc() {
      let param = {};
      this.ajaxGetAuth('/api/v1/gnb/notice', param, this.gnbNoticeFuncResult);
    },
    // 공지수 결과
    gnbNoticeFuncResult(response) {
      let result = response.result;
      if (result.code == 0) {
        this.noticeCnt = response.oNotice.cnt;
      } else {
        this.toastMsg(result.resultNoti.message);
      }
    },
    // 공지사항 메뉴 이동
    notiLink() {
      this.slidePanelClose('close');
      this.gotoBoard(36);
    },
    // 디버그모드 Slide
    debugModeLink() {
      this.slidePanelClose('close');
      const panel = this.$showPanel({
        component: () => import('@/views/slide/DebugMode'),
        openOn: 'right',
        width: screen.width,
      });
      panel.promise.then(result => {
        window.callbackBackKey = this.callbackBackKey;
        if (result.result === "close") {
          this.slidePanelClose(result);
        }
      });
    },
    // 로그아웃
    logoutFun() {
      this.slidePanelClose();
      setTimeout(() => {
        this.$router.push('/login');
      }, 400);
    }
  }
}
</script>

<style scoped>
.header-hamburger-navi-box .profile-area {
  padding: 15px;
  height: 60px;
  position: relative;
}

.header-hamburger-navi-box .profile-area .photo-area > p {
  float: left;
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 10px;
  overflow: hidden;
  background-image: url(../../assets/images/user-profile.png);
}

.header-hamburger-navi-box .profile-area .photo-area > .btn-profile-edit {
  position: absolute;
  width: 19px;
  height: 19px;
  background: url(../../assets/images/btn-profile-edit.png) no-repeat center center;
  background-size: 19px 19px;
  left: 60px;
  bottom: 10px;
  z-index: 1
}

.header-hamburger-navi-box .profile-area .photo-area .nickname-area {
  float: left;
  margin-left: 10px;
  margin-top: 7px;
}

.header-hamburger-navi-box .profile-area .photo-area .nickname-area > strong {
  display: block;
  overflow: hidden;
  font-size: 1.5rem;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.header-hamburger-navi-box .profile-area .photo-area .nickname-area > strong > span {
  width: 20px;
  margin-left: 5px;
  font-weight: 300;
  font-size: 1rem;
}

.header-hamburger-navi-box .profile-area .photo-area .nickname-area > span {
  display: block;
  float: left;
}

.header-hamburger-navi-box .profile-area .photo-area .btn-hamburger-close {
  display: inline-block;
  width: 29px;
  height: 29px;
  background: url(../../assets/images/btn-hamburger-close.png) no-repeat center;
  background-size: 29px 29px;
  position: absolute;
  top: 15px;
  right: 10px;
  border: 0;
  outline: unset
}

.header-hamburger-navi-box .profile-area .photo-area .btn-hamburger-close:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.header-hamburger-navi-box .menu-payment {
  background-image: url("../../assets/images/menu-bg-payment.png");
  background-repeat: no-repeat;
  background-size: cover;
  padding: 15px 30px 10px 30px;
  color: #fff;
  margin: 0 10px;
  border-radius: 5px;
}

.header-hamburger-navi-box .menu-payment h3 {
  font-size: 14px;
  font-weight: 300;
  font-family: sans-serif;
}

.header-hamburger-navi-box .menu-payment h2 {
  font-size: 20px;
  font-weight: 600;
  font-family: inherit;
}

.header-hamburger-navi-box .menu-payment h4 {
  font-size: 14px;
  font-weight: 300;
  font-family: sans-serif;
  padding-top: 5px;
}

.header-hamburger-navi-box .menu-payment h4 strong {
  font-weight: 600;
}

.header-hamburger-navi-box .menu-banner {
}

.header-hamburger-navi-box .noti-area {
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.header-hamburger-navi-box .noti-area button {
  display: inline-block;
  background: #eaf5ff;
  width: 133px;
  height: 40px;
  margin: 0 5px;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  text-align: left;
  border-radius: 10px;;
  outline: unset
}

.header-hamburger-navi-box .noti-area button:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.header-hamburger-navi-box .noti-area button strong {
  font-weight: 500;
  color: #0086ff;
  padding-left: 5px;
}

.header-hamburger-navi-box .noti-area .btn-note {
  padding-left: 50px
}

.header-hamburger-navi-box .noti-area .btn-note:before {
  content: "";
  background: url(../../assets/images/icon-note.png) no-repeat center;
  background-size: 14px 16px;
  position: absolute;
  left: 27px;
  top: 12px;
  z-index: 10;
  width: 14px;
  height: 16px;
}

.header-hamburger-navi-box .noti-area .btn-noti {
  padding-left: 53px;
}

.header-hamburger-navi-box .noti-area .btn-noti:before {
  content: "";
  background: url(../../assets/images/icon-noti.png) no-repeat center;
  background-size: 17px 17px;
  position: absolute;
  left: 25px;
  top: 12px;
  z-index: 10;
  width: 17px;
  height: 17px;
}

.header-hamburger-navi-box .noti-area .btn-noti.active:after {
  content: "NEW";
  right: 16px;
  top: 11px;
  z-index: 10;
  position: absolute;
  font-size: 11px;
  background-color: #ff3f56;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  padding: 2px 5px 0px 5px;
}

.header-hamburger-navi-box .logout-area {
  text-align: center;
}

.header-hamburger-navi-box .logout-area button {
  background-color: #bcbbbb;
  color: #fff;
  text-align: center;
  padding: 0 15px;
  font-size: 17px;
  display: inline-block;
  height: 50px;
  line-height: 50px;
  width: 100%;
  border-radius: 10px;
  outline: unset
}

.header-hamburger-navi-box .logout-area button:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.header-hamburger-navi-box .navi-area.middle-scroll {
  z-index: 1;
  overflow-y: auto;
}

.header-hamburger-navi-box .navi-area ul.navi > li {
  position: relative
}

.header-hamburger-navi-box .navi-area ul.navi > li > a {
  display: block;
  height: 50px;
  padding: 0 15px;
  color: #8f8e8e;
  font-size: 13px;
  line-height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.header-hamburger-navi-box .navi-area .sub-menu {
}

.header-hamburger-navi-box .navi-area .sub-menu li {
}

.header-hamburger-navi-box .navi-area .sub-menu li a {
  border-bottom: 1px solid #cccccc;
  display: block;
  height: 50px;
  padding: 0px 15px 0 15px;
  color: #000;
  line-height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  letter-spacing: -0.02em;
  font-size: 15px;
  margin: 0 15px;
}

.header-hamburger-navi-box .navi-area .sub-menu li:last-child a {
  border-bottom: none
}

.header-hamburger-navi-box .navi-area ul.navi > li > .arrow {
  border: solid #8f8e8e;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  position: absolute;
  right: 20px;
  top: 22px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transition: all ease 0.3s;
}

.header-hamburger-navi-box .navi-area ul.navi > li.active > .arrow {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transition: all ease 0.3s;
}

</style>
